<template>
  <div>
    <el-dialog :title="username+'：重置密码'"
               :visible.sync="dialogFormVisible"
               width="45%"
               class="resetPasswordDialog"
    >
      <el-form
        :model="pForm"
        :rules="pRules"
        ref="pRuleForm"
        style="text-align: center">
        <el-form-item label="输入密码：" :label-width="formLabelWidth" :required="true" prop="pwdNew">
          <el-input type="password" v-model="pForm.pwdNew" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item style="text-align: right;">
          <el-button size="mini" @click="dialogFormVisible = false" style="margin-right: 15px;">取 消</el-button>
          <el-popconfirm title="确定修改吗？" @onConfirm="updatePassword('pRuleForm')">
            <el-button size="mini" slot="reference" type="primary">保 存</el-button>
          </el-popconfirm>
        </el-form-item>
      </el-form>

    </el-dialog>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        dialogFormVisible: true,
        username: '',
        pForm: {
          userDO: {
            userId: ''
          },
          pwdNew: ''
        },
        pRules: {
          pwdNew: [{required: true, message: '请输入新密码', trigger: 'blur'}]
        },
        formLabelWidth: '120px'
      };
    },
    methods: {
      int(userId,username) {
        this.dialogFormVisible = true;
        this.username = username;
        this.pForm.userDO.userId = userId;
        this.pForm.pwdNew = '';
        this.$refs['pRuleForm'].resetFields();
      },
      updatePassword(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$httpTAG({
              url: this.$httpTAG.adornUrl("/business/sys/user/adminResetPwd"),
              method: 'post',
              data: this.pForm
            }).then(res => {
              if (res.data.code == 0) {
                this.$notify({
                  title: '操作成功！',
                  type: 'success',
                  offset: 600
                });
                this.dialogFormVisible = false
              } else {
                this.$message({ // 失败
                  type: 'fail',
                  message: res.data.msg
                })
              }
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      }
    }
  };
</script>
<style scoped>
  .resetPasswordDialog >>> .el-dialog__body {
    padding: 0px 85px 30px 20px;
  }
  .resetPasswordDialog >>> .el-dialog__header{
    padding: 20px 20px 30px 20px!important;
  }

  .resetPasswordDialog >>> .el-dialog__header {
    text-align: left;
  }

  .resetPasswordDialog >>> .el-input__suffix {
    top: -1px;
  }
</style>
